import React, { Component } from 'react'
// import './icrfPanel.scss';

export default class index extends Component {
    render() {
        return (
            <div className="icrf-panel-wrapper">
                <div className="icrf-verticle-titile">
                    ICRF
                </div>
                <div className="icrf-container">
                    <div className="icrf-left">
                        <div className="icrf-header">
                            <h2>India COVID Response Fund</h2>
                            <div className="icrf-header-bar"></div>
                        </div>
                        <div className="icrf-left-content">
                            <p>We launched <a href="https://cfstatic.giveindia.org/a1a4829a-2a74-4b0a-96b7-7c5d9b46a24f.pdf" target="_blank" style={{ color: '#008c8c'}}>India COVID Response Fund-1</a> in April 2020 raising ₹220Cr+ from individuals, foundations &amp; corporations. With the 2nd deadly wave a year later, we started ICRF-2 to support gaps in healthcare &amp; provide humanitarian aid.</p>
                        </div>
                        <div className="icrf-banner">
                            <a href="https://covid.giveindia.org/" target="_blank"><img className="icrf-banner-desk" src="https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/icrf-desktop.jpg" alt="banner-desktop" /></a>
                            <a href="https://covid.giveindia.org/" target="_blank"><img className="icrf-banner-mob" src="https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/icrf-mob.jpg" alt="banner-mobile" /></a>
                        </div>
                    </div>
                    <div className="icrf-right">
                        <div className="icrf-stats">
                            <div className="icrf-stats-item">
                                <img src="https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/icrf-raised-icon.png" alt="icon" />
                                <h3>₹ 670Cr+</h3>
                                <p>Funds raised for humanitarian aid and to augment healthcare infrastructure</p>
                            </div>
                            <div className="icrf-stats-item">
                                <img src="https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/icrf-supporters-icon.png" alt="icon" />
                                <h3>50000</h3>
                                <p>Indians supported across 22 states with funds for our COVID relief work</p>
                            </div>
                            <div className="icrf-stats-item">
                                <img src="https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/icrf-ngo-icon.png" alt="icon" />
                                <h3>300+</h3>
                                <p>NGOs and implementation partners working on ground to create widespread impact</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
